import React from "react";
import NewOperatorContent from "../components/opi/new-operator-content";

const NewOperator = () => {
  return <NewOperatorContent />;
};

export default NewOperator;
